import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import GroupInfoSidebar from 'components/group-info/GroupInfoSidebar';
import GroupProfile from 'components/group-info/GroupProfile';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import FormsSpinner from 'components/common/loaders/FormSpinner';

const GroupInfoPage = observer((): JSX.Element => {
  // Routing state
  const { groupId } = useParams<{ groupId: string }>();

  // Mobx store
  const {
    groupInfoController: { pageLoading, requestInitialData },
  } = useRootStore();

  // React effects
  useEffect(() => {
    void requestInitialData(groupId);
  }, []);

  return (
    <>
      <FormsSpinner display={pageLoading} />
      <GlobalLayout leftSection={<GroupInfoSidebar />} rightSection={<GroupProfile />} />
    </>
  );
});

export default GroupInfoPage;
